import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import { Typography, Grid } from "@material-ui/core";
import style from "style";
import { BUSINESS, BUSINESS_DEPOSIT } from "routes/paths";

const PDIC_Statement = () => {
  const history = useHistory();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const { pathname } = window.location;
    if (
      pathname === "/" ||
      pathname === "/home" ||
      pathname.includes("deposits") ||
      pathname === BUSINESS ||
      pathname === BUSINESS_DEPOSIT ||
      pathname === ""
    ) {
      setVisible(true);
    } else {
      setVisible(false);
    }
    history.listen((path) => {
      const { pathname: pathname } = path;
      if (
        pathname === "/" ||
        pathname === "/home" ||
        pathname.includes("deposits") ||
        pathname === ""
      ) {
        setVisible(true);

        return;
      }

      setVisible(false);
    });
  }, []);
  if (visible) {
    return <> Deposits are insured by PDIC up to P500,000 per depositor</>;
  }
  return <></>;
};

const Footer = ({ classes }) => {
  return (
    <Grid
      container
      justify="flex-start"
      className="gridContainer"
      style={{ paddingLeft: 20, paddingBottom: 20 }}
    >
      <Grid item md={3} lg={3}>
        <div className="flex-direction-row">
          <div style={{ flex: 0.2 }} />
          <div style={{ flex: 0.4 }}>
            <img
              alt="Bancnet logo"
              src="/images/BancnetLogo.png"
              className={classes.footerIcon}
            />{" "}
          </div>
          <div style={{ flex: 0.4 }} className="horizontal-center">
            <img
              alt="NPC Seal Of Registration"
              src="/images/logos/npc-seal-of-registration-large-2025.png"
              style={{ width: 55, height: 70 }}
            />
          </div>
        </div>
      </Grid>{" "}
      <Grid item md={9} lg={9} container>
        <Typography
          variant="caption"
          gutterBottom
        // style={{ padding: "0px 30px " }}
        >
          Copyright ©2020-2024 East West Banking Corporation.
          <br />
          A subsidiary of the Filinvest Group.
          <br />
          <PDIC_Statement />
          <br />
          For inquiries and feedback, you may call EastWest 24-Hour Customer
          Service at (+632) 8888-1700 or e-mail service@eastwestbanker.com.{" "}
          <br />
          <br />
          EastWest is regulated by the Bangko Sentral ng Pilipinas.
          https://www.bsp.gov.ph <br />
          All Rights Reserved.
        </Typography>
      </Grid>
    </Grid>
  );
};

export default withStyles(style)(Footer);
